module.exports = __webpack_public_path__ + "img/08.3901ca56.jpg";